import {
  TextInputFormikField,
  RadioGroupFormikField,
  Radio,
} from "@certn/cascadia-react";
import { t } from "i18next";

import { VERIFICATION_TYPE } from "../constants";
import { InstantEmploymentVerificationToggle } from "../../../components/verification-templates/InstantEmploymentVerificationToggle";

interface Props {
  isReadOnly?: boolean;
  digital_verification: boolean;
  handleDigitalVerificationToggle?: (v: boolean) => void;
}

export function VerificationType({
  isReadOnly,
  digital_verification,
  handleDigitalVerificationToggle,
}: Props) {
  return (
    <>
      <TextInputFormikField
        name="name"
        label={t("Template name")}
        description={t(
          "Used internally to identify the template. The applicant will not see this."
        )}
        isRequired
        testID="template-name"
      />
      <RadioGroupFormikField
        label={t("Choose a type")}
        name="check_arguments.validation_type"
        isReadOnly={isReadOnly}
        isDisabled={isReadOnly}
        isRequired
        isCard
      >
        <Radio
          testID="template-type-number"
          value={VERIFICATION_TYPE.quantity}
          description={t(
            "Request a set number of previous employers the applicant has had. Charged per employer."
          )}
        >
          {t("Number of employers")}
        </Radio>
        <Radio
          testID="template-type-years"
          value={VERIFICATION_TYPE.years}
          description={t(
            "Request a set number of years of the applicant has been employed, which could include any number of employers. Charged per number of years."
          )}
        >
          {t("Number of years")}
        </Radio>
      </RadioGroupFormikField>
      <InstantEmploymentVerificationToggle
        isReadOnly={isReadOnly}
        showBottomDivider={isReadOnly}
        digital_verification={digital_verification}
        onChange={handleDigitalVerificationToggle}
      />
    </>
  );
}
